export default "__VITE_ASSET__DqpL3wbJ__"